export default class ArticleNav {

  constructor (el) {
    this.el = el
    this.content = document.querySelector('.js-article-content')
    this.items = this.content.querySelectorAll('*')
    this.titles = []
    this.nav = []

    this.scrollToHandler = (e) => this.scrollTo(e)
  }

  init () {
    this.getTitles()
    if (!this.titles.length) {
      this.hide()
      return false;
    }
    this.getNavList()
    this.setAnchors()
    this.renderNavList()
    setTimeout(() => {
      this.initEvents()
    }, 0)
  }

  hide () {
    console.log('hide')

    const blogNavContainer = this.el.closest('.blog__nav')
    const serviceNavContainer = this.el.closest('.service__nav')

    this.el.classList.add('hide')

    if (blogNavContainer) {
      blogNavContainer.classList.add('empty')
    }
    
    if (serviceNavContainer) {
      blogNavContainer.classList.add('empty')
    }
  }

  getTitles () {
    this.items.forEach(el => {
      if (el.tagName === 'H2' || el.tagName === 'H3') {
        this.titles.push(el)
      }
    })
  }

  getNavList () {
    let index = 0
    this.titles.forEach((el, i) => {
      let id = `article-anchor-${i}`
      let name = el.textContent.trim()
      if (el.tagName === 'H2') {
        index = index + 1
        this.nav.push(
          {
            name: name,
            id: `#${id}`,
            list: []
          }
        )
      } else {
        this.nav[index - 1].list.push(
          { 
            name: name,
            id: `#${id}`
          }
        )
      }
    })
  }

  setAnchors () {
    if (!this.titles) return;

    this.titles.forEach((el, i) => {
      el.setAttribute('id', `article-anchor-${i}`)
    })
  }

  renderNavList () {
    if (!this.nav.length) return;

    let ul = document.createElement('ul')

    this.nav.forEach(el => {
      let li = document.createElement('li')
      let a = document.createElement('a')

      a.innerHTML = el.name
      a.setAttribute('href', el.id)
      li.appendChild(a)
      ul.appendChild(li)

      if (el.list.length) {
        let li = document.createElement('li')
        li.classList.add('article-nav__sublist')
        let innerUL = document.createElement('ul')

        el.list.forEach(el => {
          let innerLI = document.createElement('li')
          let innerA = document.createElement('a')
          innerA.innerHTML = el.name
          innerA.setAttribute('href', el.id)
          innerLI.appendChild(innerA)
          innerUL.appendChild(innerLI)
        })

        li.appendChild(innerUL)
        ul.appendChild(li)
      }

    })

    this.el.appendChild(ul)
    
  }

  initEvents () {
    const links = this.el.querySelectorAll('a')

    if (!links.length) return;

    links.forEach(el => {
      el.addEventListener('click', this.scrollToHandler)
    })
  }

  scrollTo (e) {
    e.preventDefault()
    const el = e.currentTarget
    const id = el.getAttribute('href')
    const target = document.querySelector(id)
    const offset = 20

    if (!target) return;
    
    const distance = target.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({
      top: distance,
      behavior: "smooth"
    })
  }

}
